import { action } from 'satcheljs';
import { ViewType } from 'owa-calendar-actions';
import type EventScope from 'owa-service/lib/contract/EventScope';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export const forwardEvent = action(
    'surfaceForwardEvent',
    (event: CalendarEvent, eventScope: EventScope, actionSource: ViewType) => ({
        event,
        eventScope,
        actionSource,
    })
);

export const replyToMeeting = action(
    'surfaceReplyToMeeting',
    (event: CalendarEvent, isReplyAll: boolean, actionSource: ViewType) => ({
        event,
        isReplyAll,
        actionSource,
    })
);
